export default __webpack_public_path__ + "static/media/cafeBottom.6574970f.jpg";